import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  addSelectItems,
  ElementsAction,
  setCurrentTableStateAC,
} from "store/actions/table";
import { isolateElements } from "utils/builder/IScheduleLogic";
import { getCurrentNamespace } from "utils/crossTabSync";

export const useSelection = (selectedItems, id, modelId = null) => {
  const dispatch = useDispatch();

  const selectedRows = useSelector((state) => {
    const currentNs = getCurrentNamespace();
    
    if (modelId) {
      if (!currentNs || currentNs !== modelId) {
        return [];
      }
    } else if (currentNs) {
      return [];
    }
    
    const tab = state.table.tabs.find((tab) => {
      if (tab.id !== id) return false;
      
      if (modelId) {
        return tab.modelId === modelId;
      }
      
      return !tab.modelId;
    });
    
    if (tab && modelId && tab.modelId !== modelId) {
      return [];
    }
    
    return tab?.selectedRows || [];
  });

  const rows = useSelector((state) => state.table.currentTableState.rows);

  const onRowSelectionChange = useCallback(
    (selection) => {
      dispatch(setCurrentTableStateAC({ selectedRows: selection, tableId: id, modelId }));

      dispatch(
        addSelectItems({
          selectedItems: selection
            .map((item) => {
              if (item?.lineElements) {
                return item?.lineElements
              };

              return;
            })
            .flat(),
          id,
          modelId,
        })
      );
    },
    [dispatch, id, modelId]
  );

  useEffect(() => {
    const currentNs = getCurrentNamespace();
    
    if (modelId) {
      if (!currentNs || currentNs !== modelId) {
        return;
      }
    } else {
      if (currentNs) {
        return;
      }
    }
    
    
    if (!selectedItems?.length) {
      const items = rows.map((row) => row?.lineElements).flat();
      isolateElements(items, modelId);
      return;
    }
    dispatch(ElementsAction(selectedItems, modelId));
  }, [dispatch, id, rows, selectedItems, modelId]);

  return { selectedRows, onRowSelectionChange };
};

export default useSelection;
